module.exports = __webpack_public_path__ + "img/demo-pet-supplies.8b9b30c4.jpg";